// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1MOL-","left__side":"Header_left__side__FQRw7","profileImage":"Header_profileImage__8eEAP","right__side_logout":"Header_right__side_logout__3uFvZ"};